import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { of } from "rxjs";
import { delay } from "rxjs/operators";
import { IconRendererComponent } from "../../renderers/icon-renderer.component";
import { FormdataService } from "../../services/formdata.service";
import { HelpersService } from "../../services/helpers.service";
import { RestService } from "../../services/rest.service";

const DIALOG = {
  DELETE: "delete",
  UPDATE: "update",
  CREATE: "create"
};

@Component({
  selector: "app-terms-and-conditions",
  templateUrl: "./admin-tools.component.html",
  styleUrls: ["./admin-tools.component.scss"],
  providers: [DatePipe]
})
export class AdminToolsComponent implements OnInit {
  //alert message
  public alertMessage = "";
  public alertMessageClass = "";
  public showAlertMessage = false;
  private startDate = new Date();
  private endDate = new Date();

  gridType = "incoming";
  public processed_files_data: any;
  public sent_files_data: any;
  public dlt_messages_data: any;
  private gridApi;
  private gridColumnApi;
  public distributorGridApi;
  filterCriteriaForm: FormGroup;

  constructor(
    private rest: RestService,
    private route: ActivatedRoute,
    private helpers: HelpersService,
    public formdata: FormdataService,
    private _fb: FormBuilder
  ) {
    this.filterCriteriaForm = this._fb.group({ dateRange: [{ begin: this.startDate, end: this.endDate }] });
  }

  ngOnInit() {
    this.route.params.subscribe(params => this.setGridtype(params["type"], this.startDate, this.endDate));
    this.filterCriteriaForm.get('dateRange').valueChanges.subscribe(x => {
      this.showLoading();
      this.setGridtype(this.gridType, x.begin, x.end);
    });
  }

  public processed_files_columndefs = [
    {
      headerName: "",
      field: "icon",
      cellRenderer: "iconRenderer",
      cellRendererParams: {
        onClick: this.onDownload.bind(this),
        label: "R"
      },
      cellStyle: {
        textAlign: "right"
      }
    },
    { headerName: "File Id", field: "processed_file_id", hide: true }, //hidden
    { headerName: "File Type", field: "file_type", checkboxSelection: true },
    {
      headerName: "Status",
      field: "status",
      cellEditor: "agRichSelectCellEditor",
      cellEditorParams: {
        values: ["retrying", "failed", "processed", "downloaded"]
      },
      editable: true,
      onCellValueChanged: params => {
        const { newValue, oldValue, data } = params;
        if (oldValue === "processed") {
          this.refreshGrid();
          return alert("The processed is final state. It cannot be changed");
        }

        if (newValue !== oldValue) {
          this.updateFileStatus(data.processed_file_id, newValue);
        }
      }
    },
    { headerName: "Sending Entity", field: "sending_entity" },
    { headerName: "TS Control Number", field: "set_control_number" },
    { headerName: "Quote ID", field: "quote_id" },
    { headerName: "Purchase Order", field: "po_number" },
    { headerName: "Sales Order", field: "sales_order_id" },
    { headerName: "File Name", field: "file_name" },
    {
      headerName: "Download Timestamp",
      field: "downloaded_timestamp",
      filter: "agDateColumnFilter",
      valueFormatter: this.helpers.adminFormatDate,
      filterParams: this.helpers.dateFilterParams
    },
    { headerName: "Message", field: "message" }
  ];

  onDownload(params) {
    return this.rest
      .getFileDownload(params.rowNode.data.processed_file_id)
      .subscribe(response => {
        if (response) {
          let dataType = "text/plain";
          let binaryData = [];
          binaryData.push(response);
          let downloadLink = document.createElement("a");
          downloadLink.href = window.URL.createObjectURL(
            new Blob(binaryData, { type: dataType })
          );
          downloadLink.setAttribute("download", params.rowNode.data.file_name);
          document.body.appendChild(downloadLink);
          downloadLink.click();
        }
      });
  }

  public frameworkComponents = {
    iconRenderer: IconRendererComponent
  };

  map_processed_files_data(data) {
    return data.map(row => {
      return {
        processed_file_id: row.processed_file_id,
        set_control_number: row.set_control_number,
        status: row.status,
        file_name: row.file_name,
        file_type: row.file_type,
        sending_entity: row.sending_entity,
        downloaded_timestamp: new Date(row.downloaded_timestamp),
        message: row.message,
        quote_id: row.quote_id,
        po_number: row.po_number,
        sales_order_id: row.sales_order_id,
        restService: this.rest
      };
    });
  }

  public sent_files_columndefs = [
    {
      headerName: "Purchase Order ID",
      field: "purchase_orders_id",
      hide: true
    },
    {
      headerName: "",
      field: "icon",
      cellRenderer: function (params) {
        var download_file_type = params.node.data.file_type.replace(" ", "_");
        if (download_file_type && download_file_type.length > 0)
          download_file_type = download_file_type + "_";
        else download_file_type = "";

        var download_file_name =
          download_file_type + params.node.data.sent_file_id + ".edi";
        var download_content = encodeURIComponent(
          params.node.data.file_content
        );

        return (
          '<a download="' +
          download_file_name +
          '" + href="data:text/plain;charset=utf-8,' +
          download_content +
          ' " ><i class="fa fa-download pointer"></i></a>'
        );
      },
      cellStyle: {
        textAlign: "right"
      }
    },
    { headerName: "Sent File Id", field: "sent_file_id", hide: true },
    { headerName: "File Type", field: "file_type", checkboxSelection: true },
    { headerName: "Correlated Message Type", field: "correlated_message_type" },
    { headerName: "Correlated Message", field: "correlated_message" },
    {
      headerName: "Send Success",
      field: "send_success",
      cellEditor: "agRichSelectCellEditor",
      cellEditorParams: {
        values: ["SENT", "FAILED"]
      },
      editable: true,
      cellStyle: data => {
        return data.value == "SENT" ? { color: "green" } : { color: "red" };
      },
      onCellValueChanged: params => {
        const { newValue, oldValue, data } = params;
        if (newValue !== oldValue) {
          this.updateSendFileStatus(data.sent_file_id, newValue === "SENT");
        }
      }
    },
    { headerName: "Recipient", field: "recipient" },
    { headerName: "TS Control Number", field: "set_control_number" },
    { headerName: "Quote ID", field: "quote_id" },
    { headerName: "PO Number", field: "purchase_order_number" },
    { headerName: "SO Number", field: "sales_order_id" },
    { headerName: "Response Message", field: "response_message" },
    {
      headerName: "Sent Timestamp",
      field: "sent_timestamp",
      filter: "agDateColumnFilter",
      valueFormatter: this.helpers.adminFormatDate,
      filterParams: this.helpers.dateFilterParams
    }
  ];

  map_sent_files_data(data) {
    return data.map(row => {
      return {
        sent_file_id: row.sent_file_id,
        set_control_number: row.set_control_number,
        file_type: row.file_type,
        correlated_message_type: row.correlated_message_type,
        correlated_message: row.correlated_message,
        send_success: row.send_success,
        recipient: row.recipient,
        response_message: row.response_message,
        sent_timestamp: new Date(row.sent_timestamp),
        file_content: row.file_content,
        quote_id: row.quote_id,
        sales_order_id: row.sales_order_id,
        purchase_order_number: row.purchase_order_number,
        purchase_orders_id: row.purchase_orders_id
      };
    });
  }

  public dlt_messages_columndefs = [
    {
      headerName: "",
      editable: true,
      headerCheckboxSelection: true,
      headerCheckboxSelectionFilteredOnly: false,
      checkboxSelection: true
    },
    {
      headerName: "",
      field: "icon",
      cellRenderer: function (params) {
        var download_file_name =
          params.node.data.message_type.replace(" ", "_") +
          "_" +
          params.node.data.message_id +
          ".json";
        var download_content = encodeURIComponent(
          params.node.data.message_content
        );
        var cellValue =
          '<a download="' +
          download_file_name +
          '" href="data:text/plain;charset=utf-8,' +
          download_content +
          '"><i class="fa fa-download pointer"></i></a>';
        return cellValue;
      },
      cellStyle: {
        textAlign: "center"
      }
    },
    { headerName: "Message Id", field: "message_id", hide: true },
    { headerName: "Message Type", field: "message_type" },
    {
      headerName: "Send Success",
      field: "send_success",
      cellStyle: data => {
        return data.value == "SENT" ? { color: "green" } : { color: "red" };
      }
    },
    { headerName: "Quote ID", field: "quote_number" },
    { headerName: "PO Number", field: "purchase_order_number" },
    { headerName: "SO Number", field: "sales_order_number" },
    { headerName: "Integration Type", field: "integration_type" },
    { headerName: "Blockchain Id", field: "blockchain_id", hide: true },
    { headerName: "Response Message", field: "response_message" },
    {
      headerName: "Sent Timestamp",
      field: "sent_timestamp",
      filter: "agDateColumnFilter",
      valueFormatter: this.helpers.adminFormatDate,
      filterParams: this.helpers.dateFilterParams
    }
  ];

  getMessageTypeFromPayload(payload) {
    const { svcReq, asset } = payload;

    if (svcReq) {
      return svcReq;
    }

    if (asset) {
      return "asset";
    }

    return "export";
  }

  map_dlt_messages_data(data) {
    return data.map(row => {
      let sales_order_number, purchase_order_number, quote_number;

      const {
        id,
        message_content,
        response_message,
        sent_timestamp,
        send_success,
        message_id,
        sales_order_id,
        blockchain_id,
        integration_type
      } = row;
      const msgJson = JSON.parse(message_content);

      const message_type = this.getMessageTypeFromPayload(msgJson);
      switch (message_type) {
        case "package":
          //sales_order_number = msgJson.payload.sales_order_number;
          purchase_order_number = msgJson.asset.purchase_order_number;
          quote_number = msgJson.asset.quote_number;
          sales_order_number = msgJson.asset.sales_order_number;
          break;
        case "invoice":
          //sales_order_number = msgJson.payload.sales_order_number;
          purchase_order_number = msgJson.asset.purchase_order_number;
          quote_number = msgJson.asset.quote_number;
          sales_order_number = msgJson.asset.sales_order_number;
          break;
        case "PUBLISH_PO":
          purchase_order_number = msgJson.asset.purchase_order_number;
          quote_number = msgJson.asset.quote_number;
          sales_order_number = msgJson.asset.sales_order_number;
          break;
        case "export":
          sales_order_number = sales_order_id;
          purchase_order_number = quote_number = "";
          break;
        case "asset":
          sales_order_number = msgJson.asset.sales_order_number;
          purchase_order_number = msgJson.asset.purchase_order_number;
          quote_number = msgJson.asset.quote_number;
          break;
        default:
      }

      return {
        purchase_orders_id: id,
        message_id,
        message_type:
          message_type &&
            (message_type == "PUBLISH_PO" || message_type == "export")
            ? "purchase order"
            : message_type,
        send_success,
        response_message,
        integration_type,
        blockchain_id,
        sent_timestamp: new Date(sent_timestamp),
        message_content,
        sales_order_number,
        purchase_order_number,
        quote_number
      };
    });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.autoSizeColumns();
  }

  autoSizeColumns() {
    if (!this.gridColumnApi) return;

    var allColumnIds = [];
    this.gridColumnApi.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.colId);
    });
    this.gridColumnApi.autoSizeColumns(allColumnIds);
  }

  onFirstDataRendered(params) {
    this.autoSizeColumns();
  }

  refreshGrid() {
    this.setGridtype(this.gridType);
  }

  showLoading() {
    this.gridApi.showLoadingOverlay();
  }

  hideLoading() {
    this.gridApi.hideOverlay();
  }

  setGridtype(value: string, dateFrom?, dateTo?) {
    if (value === "undefined" || !value) {
      value = "incoming";
    }

    if (value === "incoming") {
      this.gridType = "incoming";
    } else if (value === "outgoing") {
      this.gridType = "outgoing";
    } else if (value === "dlt") {
      this.gridType = "dlt";
    }

    if (value === "incoming") {
      return this.rest.getProcessedFiles(dateFrom && dateFrom.toISOString(), dateTo&& dateTo.toISOString()).subscribe(data => {
        if (data)
          this.processed_files_data = this.map_processed_files_data(data);
      });
    } else if (value === "outgoing") {
      return this.rest.getSentFiles(dateFrom && dateFrom.toISOString(), dateTo&& dateTo.toISOString()).subscribe(data => {
        if (data) this.sent_files_data = this.map_sent_files_data(data);
      });
    } else if (value === "dlt") {
      return this.rest.getDltMessages().subscribe(data => {
        if (data) {
          this.dlt_messages_data = this.map_dlt_messages_data(data);
        }
      });
    }
  }

  reprocessSelectedFiles() {
    //get the selected rows
    var selected = this.gridApi.getSelectedNodes();

    if (!selected) return;

    //create a list of ids to reprocess from the selected rows
    let processed_file_ids = "";
    selected.forEach(row => {
      processed_file_ids += row.data.processed_file_id + ",";
    });

    if (processed_file_ids.length <= 1) return;

    //remove trailing comma
    processed_file_ids = processed_file_ids.slice(0, -1);

    this.showLoading();
    return this.rest.putReprocessFiles(processed_file_ids).subscribe(() => {
      this.refreshGrid();
    });
  }

  resendDLTMessages() {
    const selected = this.gridApi.getSelectedNodes();
    const payload = selected.map(s => s.data);
    this.showLoading();
    return this.rest.postResendDltMessages(payload).subscribe(data => {
      setTimeout(() => this.refreshGrid(), 10000);
    });
  }

  republishSentFiles() {
    //get the selected rows
    const selected = this.gridApi.getSelectedNodes();
    if (!selected) return;

    const sent_file_ids = selected.map(row => row.data.sent_file_id);
    this.showLoading();
    return this.rest.putRepublishEdi(sent_file_ids).subscribe(data => {
      this.refreshGrid();
    });
  }

  showResponseMessage(dialogType, success) {
    switch (dialogType) {
      case DIALOG.DELETE:
        this.alertMessage = success
          ? "Distributor Deleted"
          : "Error Deleting Distributor Entity";
        break;
      case DIALOG.UPDATE:
        this.alertMessage = success
          ? "Distributor Successfully Updated"
          : "Error Updating  Distributor Entity";
        break;
      case DIALOG.CREATE:
        this.alertMessage = success
          ? "Distributor Successfully Added"
          : "Error Creating Distributor Entity. Customer Reference Number May Already Exist";
        break;
      default:
    }

    this.alertMessageClass = success ? "alert-success" : "alert-danger";
    this.showAlertMessage = true;

    //hide the button after 3 seconds
    const delay_observable = of("").pipe(delay(3000));
    delay_observable.subscribe(s => {
      this.showAlertMessage = false;
    });
  }

  updateFileStatus(processed_file_id, status) {
    if (!processed_file_id) return;

    this.showLoading();
    return this.rest
      .putUpdateFileStatus(processed_file_id, status)
      .subscribe(() => {
        this.refreshGrid();
      });
  }

  updateSendFileStatus(processed_file_id, success) {
    this.showLoading();
    return this.rest
      .putUpdateSendFileStatus(processed_file_id, success)
      .subscribe(() => {
        this.refreshGrid();
      });
  }
}
